import { cn, ui } from '../lib/ui';
import { ORG_TYPES, ORG_TYPE_POLICIES } from '../lib/orgTypes';

const POINTS = {
  community: [
    'Events, calendar, forums, videos and groups',
    'Charged by transaction',
    'No donations',
  ],
  nonprofit: [
    'Everything in Community',
    'Donations to your nonprofit, with your own fee and donor disclosures',
    'Needs a verified nonprofit profile (EIN, IRS status, California registration)',
  ],
  investment: [
    'Core tools for an investment community',
    'A flat fee for each service, never a share of a transaction',
    'Member services such as entity formation and cap table management',
    'Needs a verified compliance profile; no donations',
  ],
};

/**
 * Choose community, nonprofit or investment (docs/Decisions.md D64) as a
 * group of radio cards. `disabled` locks the choice (the org has members and
 * only the platform team can change it).
 */
export default function OrgTypePicker({ value, onChange, disabled = false }) {
  return (
    <fieldset className="m-0 border-0 p-0" disabled={disabled}>
      <legend className="sr-only">Organization type</legend>
      <div className="flex flex-col gap-3">
        {ORG_TYPES.map(type => {
          const policy = ORG_TYPE_POLICIES[type];
          const selected = value === type;
          const id = `org-type-${type}`;
          return (
            <label
              key={type}
              htmlFor={id}
              className={cn(
                'flex cursor-pointer items-start gap-3 rounded-z-card p-4',
                selected ? 'border-2 border-dcon-brand bg-dcon-brand-soft' : 'border border-z-line',
                disabled && 'cursor-not-allowed opacity-70'
              )}
            >
              <input
                id={id}
                type="radio"
                name="org-type"
                value={type}
                className="mt-1 size-4 shrink-0 accent-dcon-brand"
                checked={selected}
                onChange={() => onChange(type)}
              />
              <span>
                <strong className="block">{policy.label}</strong>
                <span className={cn(ui.muted, 'text-body-s')}>{policy.summary}</span>
                <ul className="mt-2 mb-0 list-disc pl-5 text-body-s">
                  {POINTS[type].map(point => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
